
<template>
  <v-card elevation="0" class="text-left" :uuid="uuid">
    <v-card-text>
      <qr-code-vue
        class="qrcode-code-image"
        :value="inviteCooperateLink"
        :size="280"
        :margin="40"
      />

      <v-textarea
        class="mt-4"
        rows="10"
        :value="shareText"
        readonly
        outlined
        dense
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<script lang="babel" type="text/babel">
import qrCodeVue from 'qrcode.vue'
import { read } from 'xlsx'
export default {
  props: {
    popupConfig: {
      type: Object,
    },
  },
  components: {
    qrCodeVue,
  },
  computed: {
    uuid() {
      return this.popupConfig.uuid
    },
    inviteCooperateLink() {
      return this.popupConfig.inviteCooperateLink
    },
    shareText() {
      return this.popupConfig.shareText
    },
  },
}
</script>

<style lang="sass" type="text/sass">
.qrcode-code-image
</style>
